var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardreviveWordmarkOnlight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "585 90 700 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#1B6FE8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m596.97,347.95c0-9.75,1.77-20.38,4.88-32.33l31.88-119.11c20.35-75.26,78.36-100.92,177.1-100.92,83.67,0,127.95,18.14,127.95,68.17,0,9.3-1.33,19.48-4.43,30.56l-5.31,19.91h-87.23l.9-3.54c3.09-12.37,4.86-22.57,4.86-30.98,0-22.57-13.28-31.88-50.47-31.88-51.36,0-67.74,17.71-80.58,65.08l-23.02,86.33c-3.54,13.29-5.76,24.37-5.76,33.22,0,23.02,13.73,32.33,50.92,32.33,51.36,0,65.53-8.88,77.92-56.25l2.66-10.18h87.23l-4.44,17.26c-21.25,83.69-78.36,100.95-177.1,100.95-83.24,0-127.95-18.16-127.95-68.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1271.73,165.98c0,7.53-1.35,15.49-3.54,24.35l-8.43,31.88c-10.63,40.28-38.07,65.53-81.47,78.37l49.59,111.13h-95.19l-44.72-100.05h-2.22l-58.42-.45-27.01,100.5h-87.23l83.24-309.93h145.67c85.01,0,129.73,18.61,129.73,64.21Zm-90.77,16.81c0-19.03-13.29-28.78-53.13-28.78h-58.44l-27.89,104.94,57.99.45c51.36.45,67.3-17.71,76.15-49.14l2.2-7.98c2.22-7.08,3.12-13.72,3.12-19.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardreviveWordmarkOnlight);
export default __webpack_public_path__ + "static/media/cardrevive-wordmark-onlight.050030185e72bd48526d1f9629ce82c5.svg";
export { ForwardRef as ReactComponent };